// Module
var code = "<template> <require from=\"app/cd/components/summary/auth/auth-summary\"></require> <auth-summary auth-id.bind=\"authId\" member-id.bind=\"memberId\"></auth-summary> </template> ";
// Exports
module.exports = code;